import { IIdsRequest } from "../../model/request/IIdsRequest";
import { IKienThuc } from "../../model/respone/category/IKienThuc";
import { apiClient } from "../apiClient";
export const KIEN_THUC_API = "chuong-trinh-dao-tao-kien-thuc";
export const kienThucApi = {
  SelectAll: () => apiClient.get(`${KIEN_THUC_API}`),
  Insert: (payload: IKienThuc) => apiClient.post(`${KIEN_THUC_API}`, payload),
  Update: (payload: IKienThuc) => apiClient.put(`${KIEN_THUC_API}`, payload),
  Delete: (id: IIdsRequest) => apiClient.post(`${KIEN_THUC_API}/deletes`, id),
};
